import { Loader } from '@pvh/loader';
import React, { ReactNode, useState } from 'react';
import { InitialDataProps, withInitialData } from '../hocs/withInitialData';
import useAvailableLanguages, {
  fallbackLanguage,
  InterfaceLanguage,
} from './useAvailableLanguages';

export type LanguageContextType = {
  currentLanguage: InterfaceLanguage;
  // after initial language setup, setLanguage should be triggered only by user action (like click or change)
  setLanguage: (language: InterfaceLanguage) => void;
  languages: Readonly<InterfaceLanguage[]>;
};

export const LanguageContext = React.createContext<LanguageContextType>({
  currentLanguage: fallbackLanguage,
  setLanguage: () => {},
  languages: [],
});

interface Props {
  children: ReactNode;
}
export const LanguageProvider = withInitialData(
  ({ children, country, tenant }: Props & InitialDataProps): JSX.Element => {
    const { defaultLanguage, availableLanguages, loading } =
      useAvailableLanguages(country, tenant);

    const [language, setLanguage] = useState<InterfaceLanguage | undefined>();

    if (country && (loading || !defaultLanguage)) return <Loader />;

    const languageContext: LanguageContextType = {
      currentLanguage: language || defaultLanguage || fallbackLanguage,
      setLanguage: setLanguage,
      languages: availableLanguages,
    };

    return (
      <LanguageContext.Provider value={languageContext}>
        {children}
      </LanguageContext.Provider>
    );
  }
);
